import _ from 'lodash';
import isBefore from 'date-fns/is_before';
import { slashDateToISO } from 'client/utils/format';


export function mergeParentChildResponses(formData, childKey) {
  const followUpResponses = _.get(formData, childKey);
  // followUpResponses takes this shape
  // {
  //   ffm_question_key: {
  //       [memberId1]: formData,
  //       [memberId2]: formData,
  //     }
  // }
  // combine follow up responses with the parent question responses
  const mergedResponses = _.reduce(
    followUpResponses,
    (acc, fuResponse, questionKey) => {
      const parentResponses = formData[questionKey];
      // parentResponses takes this shape
      //  [
      //     { id: memberId1, title: title1, ... },
      //     { id: memberId2, title: title2, ... },
      //   ]

      acc[questionKey] = _.map(parentResponses, parentResponse => (
        {
          ...parentResponse,
          ...fuResponse[parentResponse.id],
        }
      ));

      return acc;
    },
    {},
  );
  return mergedResponses;
}

export function isFfmRedirect(formData, questionData) {
  return !_.every(questionData, (question) => {
    const answer = _.get(formData, `${question.key}`);
    const passingResponse = _.get(question, 'passingResponse');
    if (_.isBoolean(passingResponse)) return passingResponse === answer;
    return true;
  });
}

export function getAppQe(events, questions) {
  if (!events) return {};
  const flattenEvents = _.reduce(events, (acc, event, key) => {
    _.forEach(event, member => acc.push({
      key,
      date: member.date,
    }));
    return acc;
  }, []);

  const latestEvent = _.reduce(flattenEvents, (acc, event) => {
    if (isBefore(acc.date, event.date)) {
      return event;
    }
    return acc;
  });

  const qeKey = _.get(_.find(questions, ['key', latestEvent.key]), 'qeKey');
  return {
    qualifying_event: qeKey,
    qualifying_event_date: slashDateToISO(latestEvent.date),
  };
}

export function mergeAppJson(appJson, path, dataToMerge) {
  const jsonAtPath = _.get(appJson, path);
  let mergedAtPath;
  if (_.isArray(dataToMerge) || dataToMerge === null) {
    mergedAtPath = dataToMerge;
  } else {
    mergedAtPath = { ...jsonAtPath, ...dataToMerge };
  }
  return _.set(appJson, path, mergedAtPath);
}
